
import { gql } from "@apollo/client";

export const OFFER_VAT_FINANCING_UPDATED = gql`
  subscription VatFinancingUpdated($documentId: Int!, $siteId: Int!) {
    vatFinancingUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      amount
      durationMonths
      maxDurationMonths
      minDurationMonths
      graceMonths
      interestPercent
    }
  }
`;

export const OFFER_VAT_FINANCING_INVALIDATED = gql`
  subscription VatFinancingInvalidated($documentId: Int!, $siteId: Int!) {
    vatFinancingInvalidated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;

